@if (showLoading) {
  <div class="loading-overlay">
    <div class="spinner"></div>
  </div>
}

<app-navbar></app-navbar>
<router-outlet />